module.exports = __webpack_public_path__ + "static/logo-gc-c2c37d427b77d470cd8d659e1cf2d245.png";